import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

type ObjectCodeLinkProps = {
  url: string
  text: string | undefined | null
  disabled?: boolean
}

export const ObjectCodeLink = (props: ObjectCodeLinkProps) => {
  const [url, setUrl] = useState<string>()
  const [text, setText] = useState<string>()
  const [disabled, setDisabled] = useState<boolean | undefined>()

  useEffect(() => {
    if (props.disabled !== undefined) setDisabled(props.disabled)
    else setDisabled(false)

    setUrl(props.url)

    if (props.text) setText(props.text)
  }, [props.disabled, props.text, props.url])

  return disabled ? (
    <>
      <>{text}</>
    </>
  ) : (
    <Link to={`${url}`}>{text}</Link>
  )
}
